export const AD_TYPES = ['all', 'dynamic', 'streaming'] as const;
